import React, { useEffect, useState } from "react";
import "../../styles/otpverify.css";
import { useNavigate, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { otpCheck } from "../../store/actions";
import Logo from "../../images/light_- vertical.png";

const Otpverify = (props) => {
  const { mobileno } = useParams();
  const [otp, setOtp] = useState("");
  const [verificationRequested, setVerificationRequested] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!verificationRequested) return;

    const isLoggedIn =
      localStorage.getItem("isLoggedIn") === "true";

    if (props.error === "success" && isLoggedIn) {
      localStorage.setItem(
        "managerMobile",
        String(mobileno || "")
      );

      navigate("/dashboard/tours/bookings", {
        replace: true,
      });
    }
  }, [
    verificationRequested,
    props.error,
    props.loginState,
    mobileno,
    navigate,
  ]);

  const handleOTPVerification = () => {
    if (otp.length !== 4) return;

    /*
     * Clear any previous successful-login value so an old
     * LOGIN_SUCCESS state cannot trigger the redirect.
     * The OTP success saga should set this back to "true".
     */
    localStorage.setItem("isLoggedIn", "false");

    setVerificationRequested(true);

    props.otpCheck({
      mobile: mobileno,
      otp,
    });
  };

  const handleOtpChange = (event) => {
    const numericOtp = event.target.value
      .replace(/\D/g, "")
      .slice(0, 4);

    setOtp(numericOtp);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && otp.length === 4) {
      handleOTPVerification();
    }
  };

  return (
    <main className="auth-shell auth-shell--otp">
      <section className="auth-hero" aria-label="Secure verification">
        <div className="auth-hero__orb auth-hero__orb--one" />
        <div className="auth-hero__orb auth-hero__orb--two" />
        <div className="auth-hero__content">
          <div className="auth-hero__badge">
            <span />
            Secure manager access
          </div>
          <h1>One quick check. Then you’re in control.</h1>
          <p>
            Enter the four-digit one-time password sent to your registered
            mobile number to open the GoodMove manager workspace.
          </p>
        </div>
      </section>

      <section className="auth-panel">
        <div className="auth-card auth-card--otp">
          <div className="auth-card__brand">
            <img src={Logo} alt="GoodMove" />
            <span>Identity verification</span>
          </div>

          <div className="auth-card__heading">
            <span className="auth-card__kicker">SECURE SIGN-IN</span>
            <h2>Enter your OTP</h2>
            <p>
              We sent a four-digit code to
              <strong className="auth-mobile-number"> +91 {mobileno}</strong>
            </p>
          </div>

          <div className="auth-form">
            <label htmlFor="manager-otp">One-time password</label>
            <input
              id="manager-otp"
              className="auth-otp-input"
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              maxLength={4}
              placeholder="••••"
              name="otp"
              value={otp}
              onChange={handleOtpChange}
              onKeyDown={handleKeyDown}
              autoFocus
            />

            <button
              type="button"
              disabled={otp.length !== 4}
              onClick={handleOTPVerification}
              className="auth-primary-button"
            >
              Verify and open workspace
              <span aria-hidden="true">→</span>
            </button>

            {props.message && (
              <div className="auth-message" aria-live="polite">
                {props.message}
              </div>
            )}
          </div>

          <div className="auth-card__security">
            <span className="auth-card__security-icon">✓</span>
            <span>
              <strong>Encrypted verification</strong>
              <small>The code is valid only for this sign-in attempt.</small>
            </span>
          </div>
        </div>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => {
  const loginState = state.Login || {};
  const { error, message } = loginState;

  return {
    error,
    message,
    /*
     * Mapping the complete Login object ensures the component
     * rerenders after LOGIN_SUCCESS, even when error remains
     * the same value as an earlier login action.
     */
    loginState,
  };
};

export default connect(mapStateToProps, {
  otpCheck,
})(Otpverify);


// import React, { useEffect, useState } from "react";
// import "../../styles/otpverify.css";
// import { useNavigate, useParams } from "react-router-dom";
// import { connect } from "react-redux";
// import { otpCheck } from "../../store/actions";

// const Otpverify = (props) => {
//   const { mobileno } = useParams();
//   const [otp, setOtp] = useState("");
//   const [verificationRequested, setVerificationRequested] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (!verificationRequested) return;

//     const isLoggedIn =
//       localStorage.getItem("isLoggedIn") === "true";

//     if (props.error === "success" && isLoggedIn) {
//       localStorage.setItem(
//         "managerMobile",
//         String(mobileno || "")
//       );

//       navigate("/dashboard/tours/bookings", {
//         replace: true,
//       });
//     }
//   }, [
//     verificationRequested,
//     props.error,
//     props.loginState,
//     mobileno,
//     navigate,
//   ]);

//   const handleOTPVerification = () => {
//     if (otp.length !== 4) return;

//     /*
//      * Clear any previous successful-login value so an old
//      * LOGIN_SUCCESS state cannot trigger the redirect.
//      * The OTP success saga should set this back to "true".
//      */
//     localStorage.setItem("isLoggedIn", "false");

//     setVerificationRequested(true);

//     props.otpCheck({
//       mobile: mobileno,
//       otp,
//     });
//   };

//   const handleOtpChange = (event) => {
//     const numericOtp = event.target.value
//       .replace(/\D/g, "")
//       .slice(0, 4);

//     setOtp(numericOtp);
//   };

//   const handleKeyDown = (event) => {
//     if (event.key === "Enter" && otp.length === 4) {
//       handleOTPVerification();
//     }
//   };

//   return (
//     <div className="mainDiv-container">
//       <div className="mainDiv">
//         <h3>Enter Your OTP</h3>

//         <div className="otpDiv">
//           <input
//             type="text"
//             inputMode="numeric"
//             autoComplete="one-time-code"
//             maxLength={4}
//             placeholder="Enter your OTP"
//             name="otp"
//             value={otp}
//             onChange={handleOtpChange}
//             onKeyDown={handleKeyDown}
//             style={{ textAlign: "center" }}
//           />

//           <button
//             type="button"
//             disabled={otp.length !== 4}
//             onClick={handleOTPVerification}
//           >
//             Verify
//           </button>

//           {props.message && (
//             <div aria-live="polite">
//               {props.message}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// const mapStateToProps = (state) => {
//   const loginState = state.Login || {};
//   const { error, message } = loginState;

//   return {
//     error,
//     message,
//     /*
//      * Mapping the complete Login object ensures the component
//      * rerenders after LOGIN_SUCCESS, even when error remains
//      * the same value as an earlier login action.
//      */
//     loginState,
//   };
// };

// export default connect(mapStateToProps, {
//   otpCheck,
// })(Otpverify);

// // import React, { useEffect, useState } from "react";
// // import "../../styles/otpverify.css";
// // import { useNavigate, useParams } from "react-router-dom";
// // import { connect } from "react-redux";
// // import { otpCheck } from "../../store/actions";

// // const Otpverify = (props) => {
// //   const { mobileno } = useParams();
// //   const [otp, setOtp] = useState("");
// //   const [verificationRequested, setVerificationRequested] = useState(false);
// //   const navigate = useNavigate();

// //   useEffect(() => {
// //     if (verificationRequested && props.error === "success" && props.message === "OTP verified success") {
// //       localStorage.setItem("managerMobile", String(mobileno || ""));
// //       localStorage.setItem("isLoggedIn", "true");
// //       navigate("/dashboard/tours/bookings", { replace: true });
// //     }
// //   }, [verificationRequested, props.error, props.message, mobileno, navigate]);

// //   const handleOTPVerification = () => {
// //     if (otp.length !== 4) return;
// //     setVerificationRequested(true);
// //     props.otpCheck({ mobile: mobileno, otp });
// //   };

// //   return (
// //     <div className="mainDiv-container">
// //       <div className="mainDiv">
// //         <h3>Enter Your OTP</h3>
// //         <div className="otpDiv">
// //           <input
// //             type="text"
// //             inputMode="numeric"
// //             maxLength={4}
// //             placeholder="Enter your OTP"
// //             name="otp"
// //             value={otp}
// //             onChange={(event) => setOtp(event.target.value.replace(/\D/g, ""))}
// //             onKeyDown={(event) => {
// //               if (event.key === "Enter" && otp.length === 4) handleOTPVerification();
// //             }}
// //             style={{ textAlign: "center" }}
// //           />
// //           <button disabled={otp.length !== 4} onClick={handleOTPVerification}>Verify</button>
// //           {props.message && <div aria-live="polite">{props.message}</div>}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // const mapStateToProps = (state) => {
// //   const { error, message } = state.Login;
// //   return { error, message };
// // };

// // export default connect(mapStateToProps, { otpCheck })(Otpverify);


// // // import React, { useState } from "react";
// // // import { useSelector } from "react-redux";
// // // import "../../styles/otpverify.css";
// // // import { useNavigate, useParams } from "react-router-dom";
// // // import { connect } from "react-redux";
// // // import PropTypes from "prop-types";
// // // // Here - loginUser,
// // // import { loginSuccess, otpCheck } from "../../store/actions";

// // // const Otpverify = (props) => {
// // //   const { mobileno } = useParams();
// // //   const [otp, setOtp] = useState("");
// // //   const navigate = useNavigate();
// // //   const otpObj = {
// // //     mobile: mobileno,
// // //     otp: otp,
// // //   };
// // //   const handleOTPVerification = async () => {
// // //     await props.otpCheck(otpObj);
// // //   };
// // //   console.log(props);
// // //   if (props.error == "success" && props.message == "OTP verified success") {
// // //     setTimeout(() => {
// // //       navigate("/dashboard/tours");
// // //     }, 1200);
// // //   } else {
    
// // //   }

// // //   return (
// // //     <>
// // //       <div className="mainDiv-container">
// // //         <div className="mainDiv">
// // //             <h3>Enter Your OTP </h3>
// // //             <div className="otpDiv">
// // //                 <input
// // //                   type="text"
// // //                   maxLength={4}
// // //                   placeholder="Enter your Otp"
// // //                   name="otp"
// // //                   onChange={(e) => setOtp(e.target.value)}
// // //                   style={{textAlign:"center"}}
// // //                 />
              
// // //               <button onClick={handleOTPVerification}>Verify</button>
// // //               {props.message}
// // //             </div>
// // //         </div>
// // //       </div>
// // //     </>
// // //   );
// // // };

// // // const mapStateToProps = (state) => {
// // //   console.log(state);
// // //   const { error, message } = state.Login;

// // //   return { error, message };
// // // };

// // // // here - ,{loginUser}

// // // export default connect(mapStateToProps, { otpCheck })(Otpverify);
